<template>
  <main class="l-main">
    <div class="l-error c-card">
      <div class="l-error__inner-red">
        <div class="l-error__message l-error__message--red">
          <span
            ><Icon name="alert" color="#CC0621" width="31" height="28"
          /></span>
          <p>
            セッションタイムアウトになりました。
            <br />
            お手数ですが、再度ログインしてください。
          </p>
        </div>

        <div class="l-error__btn">
          <div class="c-buttonWrap4">
            <ButtonLink tag="a" :href="redirectUrl" style-type="primary" color="color2">
              ログイン
            </ButtonLink>
            <br />
            <CButton @click.native="logout" style-type="primary" color="color2">
            ログアウト
            </CButton>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  props: ["error"],
  computed: {
    redirectUrl() {
      // 戻り先 url の設定が必要
      return (
        process.env.VUE_APP_AUTH_FACADE +
        "?callback_authorization_start_uri=" +
        process.env.VUE_APP_API_DOMAIN +
        "/v1/stay/auth-start"
      );
    },
  },
  methods: {
    // ログアウト処理実行
    async logout() {
      // CRM独自対応
      // window.dataLayer.push({
      //   event: "braze_logout",
      // });
      await this.$auth.remove();
      // ip-sdk.min.jsログアウト処理 ※userInfoが存在するときのみ実行
      // if(Cookies.get('userInfo')) {
      //   try{
      //     await window.sdk.signout("POST");
      //     document.getElementById('login-script').remove();
      //   }catch(e){
      //     console.log(e);
      //   }
      // }
      // userInfo自体を削除する
      // Cookies.remove('userInfo');
    }
  },
  mounted() {
    this.$meta.setDocumentTitle("セッションタイムアウトになりました。");
    this.$page.isBreadcrumb = false;
    this.$page.isPageHeader = false;
    this.$page.isPageTop = false;
    this.$page.isSubHeader = true;
    this.$page.showFooterMenu = false;
    // Remove logic authenticationLevel
    // if(this.$route.query.authenticationLevel != 1){
    //   this.logout();
    // }
  },
  watch: {
    $route() {
      this.$meta.setDocumentTitle("セッションタイムアウトになりました。");
      this.$page.isBreadcrumb = false;
      this.$page.isPageHeader = false;
      this.$page.isPageTop = false;
      this.$page.isSubHeader = true;
      this.$page.showFooterMenu = false;
      // Remove logic authenticationLevel
      //   if(this.$route.query.authenticationLevel != 1){
      //     this.logout();
      //   }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./l-error.scss";
@import "./l-main.scss";
</style>
